module.exports = __webpack_public_path__ + "img/1543940348.6096eb82.jpg";